// API/queryClient.js
import { QueryClient } from "@tanstack/react-query"
import { notify } from "UI/Toast/toast"

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // data stays fresh for 5 minutes
			retry: (failureCount, error) => {
				// don't retry on 4xx errors — only on network/server issues
				if (error?.status >= 400 && error?.status < 500) return false
				return failureCount < 2
			},
		},
		mutations: {
			retry: false,
			onError: (error) => {
				notify.error(error?.message ?? "Something went wrong")
			},
		},
	},
})

export default queryClient
